import { render, staticRenderFns } from "./TreatmentRenewOfferEmailTemplate.vue?vue&type=template&id=1821f728&scoped=true"
import script from "./TreatmentRenewOfferEmailTemplate.vue?vue&type=script&lang=js"
export * from "./TreatmentRenewOfferEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./TreatmentRenewOfferEmailTemplate.vue?vue&type=style&index=0&id=1821f728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821f728",
  null
  
)

export default component.exports